import React from 'react';

/**
 * Card - Container component with glassy zinc-900 styling
 * Replaces: bg-zinc-900 border-zinc-800 rounded-xl p-5
 */
export const Card = ({ children, className = "", padding = "p-5", noBorder = false }) => (
  <div className={`bg-card backdrop-blur-md ${noBorder ? '' : 'border border-subtle'} rounded-xl ${padding} ${className}`}>
    {children}
  </div>
);

/**
 * CardHeader - Standard header with icon, title, and optional right element
 */
export const CardHeader = ({ title, icon: Icon, iconColor = "text-primary", rightElement, className = "" }) => (
  <div className={`flex items-center justify-between mb-5 border-b border-subtle pb-3 ${className}`}>
    <div className="flex items-center gap-3">
      {Icon && <Icon className={`${iconColor} w-5 h-5`} />}
      <h3 className="text-lg font-bold text-white tracking-tight">{title}</h3>
    </div>
    {rightElement}
  </div>
);

/**
 * CardSection - Subsection within a card with border separator
 */
export const CardSection = ({ children, className = "" }) => (
  <div className={`pt-4 border-t border-subtle ${className}`}>
    {children}
  </div>
);

/**
 * CardCompact - Smaller card for stats, grid items
 * Replaces: bg-zinc-800/50 rounded-lg p-3 text-center
 */
export const CardCompact = ({ children, className = "", centered = true }) => (
  <div className={`bg-subtle/50 rounded-lg p-3 ${centered ? 'text-center' : ''} ${className}`}>
    {children}
  </div>
);
